import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "q-gutter-md"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_account_loader = _resolveComponent("account-loader")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_select_role = _resolveComponent("select-role")!
  const _component_async_btn = _resolveComponent("async-btn")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: _ctx.title,
    size: "xs",
    ref: "modal"
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_async_btn, {
        label: "Save",
        color: "primary",
        task: _ctx.task,
        onClick: _ctx.save
      }, null, 8, ["task", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_account_loader, {
        "account-id": _ctx.user.accountId,
        modelValue: _ctx.account,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.account) = $event))
      }, null, 8, ["account-id", "modelValue"]),
      (_ctx.account)
        ? (_openBlock(), _createElementBlock("form", _hoisted_1, [
            _createVNode(_component_q_input, {
              label: "First Name",
              modelValue: _ctx.local.firstName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.local.firstName) = $event)),
              outlined: ""
            }, null, 8, ["modelValue"]),
            _createVNode(_component_q_input, {
              label: "Last Name",
              modelValue: _ctx.local.lastName,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.local.lastName) = $event)),
              outlined: ""
            }, null, 8, ["modelValue"]),
            _createVNode(_component_q_input, {
              label: "Email",
              type: "email",
              "model-value": _ctx.local.email,
              outlined: "",
              disable: ""
            }, null, 8, ["model-value"]),
            _createVNode(_component_select_role, {
              "account-type": _ctx.account.type,
              modelValue: _ctx.local.role,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.local.role) = $event)),
              outlined: "",
              object: ""
            }, null, 8, ["account-type", "modelValue"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title"]))
}